const es = {
  brand: "Offertli",
  nav: {
    dashboard: "Panel",
    customers: "Clientes",
    requests: "Solicitudes",
    offers: "Ofertas",
    projects: "Proyectos",
    invoices: "Facturas",
    catalog: "Inventario",
    organization: "Organización",
    users: "Usuarios",
    settings: "Configuración",
    more: "Más",
    newRequest: "Nueva solicitud",
    notifications: "Notificaciones",
    main: "Navegación principal",
  },
  userMenu: {
    label: "Menú de usuario",
    language: "Idioma",
    logout: "Cerrar sesión",
  },
  theme: {
    label: "Apariencia",
    system: "Sistema",
    light: "Claro",
    dark: "Oscuro",
  },
  locale: {
    en: "English",
    de: "Deutsch",
    fr: "Français",
    es: "Español",
  },
  common: {
    save: "Guardar",
    cancel: "Cancelar",
    back: "Atrás",
    next: "Siguiente",
    continue: "Continuar",
    submit: "Enviar",
    close: "Cerrar",
    loading: "Cargando…",
    retry: "Reintentar",
    yes: "Sí",
    no: "No",
    optional: "opcional",
    required: "obligatorio",
    add: "Añadir",
    remove: "Eliminar",
    edit: "Editar",
    delete: "Eliminar",
    email: "Correo electrónico",
    password: "Contraseña",
    firstName: "Nombre",
    lastName: "Apellidos",
    phone: "Teléfono",
    website: "Sitio web",
    name: "Nombre",
    stepOf: "Paso {{current}} de {{total}}",
  },
  validation: {
    required: "Este campo es obligatorio.",
    email: "Introduce una dirección de correo válida.",
    minLength: "Debe tener al menos {{min}} caracteres.",
    maxLength: "Debe tener como máximo {{max}} caracteres.",
    passwordMin: "La contraseña debe tener al menos {{min}} caracteres.",
    passwordMismatch: "Las contraseñas no coinciden.",
    iban: "Introduce un IBAN válido.",
    qrIbanRequired: "Se requiere un IBAN-QR para referencias QR (QRR).",
    termsRequired: "Debes aceptar las condiciones para continuar.",
    rateRange: "La tasa debe estar entre 0 y 100.",
    invalidNumber: "Introduce un número válido.",
    tokenRequired: "Introduce tu token de configuración.",
    minOneRate: "Se requiere al menos una tasa de impuesto.",
    passwordLetter: "La contraseña debe contener al menos una letra.",
    passwordNumber: "La contraseña debe contener al menos un número.",
    passwordPolicy:
      "Utiliza al menos 10 caracteres, incluidos una letra y un número.",
    localeUnsupported: "Selecciona uno de los idiomas disponibles.",
    invalidDate: "Introduce una fecha válida.",
    invalidTime: "Introduce una hora válida.",
    endAfterStart: "La hora de fin debe ser posterior a la hora de inicio.",
    completeDateTime:
      "Introduce tanto una fecha como una hora en formato de 24 horas (HH:mm).",
  },
  errors: {
    generic: "Algo salió mal. Inténtalo de nuevo.",
    invalidFields: "Revisa los campos resaltados y corrige los errores.",
    network: "No se puede contactar con el servidor. Comprueba tu conexión.",
    sessionExpired: "Tu sesión ha caducado. Inicia sesión de nuevo.",
    forbidden: "No tienes permiso para acceder a esta página.",
    invalidCredentials: "Correo o contraseña incorrectos.",
    tooManyAttempts: "Demasiados intentos. Inténtalo más tarde.",
  },
  forbidden: {
    title: "Sin acceso",
    message: "Tu cuenta no tiene el permiso necesario para ver esta página.",
    backHome: "Volver al panel",
  },
  status: {
    draft: "Borrador",
    submitted: "Enviada",
    in_process: "En curso",
    processed: "Procesada",
    ready: "Lista",
    sent: "Enviada",
    accepted: "Aceptada",
    rejected: "Rechazada",
    declined: "Rechazada",
    planned: "Planificada",
    scheduled: "Programada",
    in_progress: "En curso",
    on_hold: "En pausa",
    completed: "Completada",
    issued: "Emitida",
    credited: "Abonada",
    unpaid: "Impagada",
    partially_paid: "Parcialmente pagada",
    paid: "Pagada",
    overpaid: "Pagada de más",
    overdue: "Vencida",
    low: "Baja",
    normal: "Normal",
    high: "Alta",
    invited: "Invitado",
    active: "Activo",
    suspended: "Suspendido",
    deactivated: "Desactivado",
  },
  auth: {
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    login: {
      title: "Iniciar sesión",
      subtitle: "Inicia sesión en tu cuenta de Offertli.",
      email: "Correo electrónico",
      password: "Contraseña",
      rememberMe: "Mantener sesión iniciada",
      submit: "Iniciar sesión",
      submitting: "Iniciando sesión…",
      forgot: "¿Olvidaste tu contraseña?",
    },
    forgot: {
      title: "Restablecer contraseña",
      subtitle:
        "Introduce tu correo electrónico y te enviaremos un enlace de restablecimiento.",
      submit: "Enviar enlace",
      sentTitle: "Revisa tu bandeja de entrada",
      sentMessage:
        "Si existe una cuenta con este correo, recibirás en breve un enlace para restablecer la contraseña.",
      backToLogin: "Volver a iniciar sesión",
    },
    reset: {
      title: "Elige una nueva contraseña",
      subtitle: "Define una nueva contraseña para tu cuenta.",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar contraseña",
      submit: "Establecer contraseña",
      successTitle: "Contraseña actualizada",
      successMessage:
        "Tu contraseña ha sido cambiada. Ya puedes iniciar sesión.",
      missingToken:
        "Este enlace de restablecimiento no es válido o ha caducado.",
      toLogin: "Ir a iniciar sesión",
    },
  },
  invite: {
    title: "Aceptar invitación",
    subtitle:
      "Bienvenido a Offertli. Define tu contraseña para activar tu cuenta.",
    invitedAs: "Has sido invitado como",
    email: "Correo electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
    acceptTerms: "Acepto las condiciones de uso y el aviso de privacidad.",
    submit: "Activar cuenta",
    invalidTitle: "Invitación no válida",
    invalidMessage:
      "Este enlace de invitación no es válido, ha caducado o ya ha sido utilizado.",
    toLogin: "Ir a iniciar sesión",
  },
  setup: {
    title: "Configurar Offertli",
    subtitle: "Configura tu empresa en unos pocos pasos.",
    alreadyDone: "La configuración ya está completada.",
    steps: {
      credential: "Acceso",
      language: "Idioma",
      industry: "Sector",
      company: "Empresa",
      address: "Dirección",
      branding: "Imagen de marca",
      systemAdmin: "Administrador del sistema",
      localization: "Localización",
      vat: "IVA",
      bank: "Banco y factura QR",
      numbering: "Numeración",
      review: "Revisión",
    },
    credential: {
      title: "Verificar acceso",
      description:
        "Introduce el token de configuración de tu servidor o abre el enlace de invitación recibido por correo.",
      tokenLabel: "Token de configuración",
      tokenHint:
        "Encontrarás el token en tu entorno de despliegue (OFFERTLI_SETUP_TOKEN).",
      validate: "Validar token",
      validating: "Validando…",
      invalid:
        "Este token no es válido o la configuración ya se ha completado.",
      inviteDetected: "Enlace de invitación detectado",
      inviteValid: "Invitación para {{email}} verificada.",
      inviteInvalid: "Este enlace de invitación no es válido o ha caducado.",
      useToken: "Usar un token de configuración",
    },
    language: {
      title: "Idioma de la interfaz",
      description: "Elige el idioma de este asistente y de tu propia interfaz.",
    },
    industry: {
      label: "Sector",
      description:
        "Elige el sector que mejor se ajuste a tu empresa. Prepararemos categorías predeterminadas adecuadas.",
      options: {
        landscaping: "Jardinería y paisajismo",
        general_services: "Servicios generales",
        construction: "Construcción",
        cleaning: "Limpieza",
        other: "Otro",
      },
    },
    company: {
      title: "Identidad de la empresa",
      name: "Nombre de la empresa",
      tradingName: "Nombre comercial",
      vatNumber: "Número de IVA / UID",
      website: "Sitio web",
    },
    address: {
      title: "Dirección y contacto",
      line1: "Dirección línea 1",
      line2: "Dirección línea 2",
      postalCode: "Código postal",
      city: "Ciudad",
      canton: "Cantón / región",
      country: "País",
      email: "Correo de la empresa",
      phone: "Teléfono",
    },
    systemAdmin: {
      title: "Administrador del sistema",
      description:
        "Define la contraseña del administrador del sistema integrado. No se crea ninguna cuenta de empleado o usuario.",
      username: "Nombre de usuario",
    },
    localization: {
      title: "Idioma, zona horaria y moneda",
      locale: "Idioma por defecto",
      localeHint:
        "Se usa para nuevos usuarios y documentos sin preferencia definida.",
      timezone: "Zona horaria",
      currency: "Moneda",
    },
    vat: {
      title: "IVA y tasas de impuesto",
      registered: "Registrado a efectos de IVA",
      registeredHint:
        "Actívalo si tu empresa está registrada a efectos de IVA.",
      rates: "Tasas de impuesto",
      ratesHint: "Define las tasas de IVA disponibles en ofertas y facturas.",
      rateName: "Nombre de la tasa",
      rateValue: "Tasa (%)",
      isDefault: "Por defecto",
      addRate: "Añadir tasa",
      standardRate: "Tasa estándar",
      noVat: "Sin IVA",
    },
    bank: {
      title: "Banco y factura QR",
      description: "Se usa para generar facturas QR suizas.",
      iban: "IBAN",
      ibanHint: "El IBAN al que deben llegar los pagos.",
      qrIbanHint:
        "Las referencias QRR requieren un IBAN-QR (QR-IID 30000–31999).",
      bankName: "Banco",
      referenceType: "Tipo de referencia",
      refNON: "Sin referencia (NON)",
      refSCOR: "Referencia de acreedor (SCOR)",
      refQRR: "Referencia QR (QRR)",
      paymentTermDays: "Plazo de pago (días)",
    },
    numbering: {
      title: "Numeración y valores por defecto",
      description:
        "Los números de documento se generan automáticamente. Podrás ajustar prefijos y formatos más tarde en la configuración.",
      paymentTermDays: "Plazo de pago (días)",
      offerValidityDays: "Validez de la oferta (días)",
      previewTitle: "Formatos de numeración por defecto",
      customer: "Cliente",
      request: "Solicitud",
      offer: "Oferta",
      project: "Proyecto",
      invoice: "Factura",
    },
    review: {
      title: "Revisar y completar",
      description: "Revisa tu configuración antes de completarla.",
      companySection: "Empresa",
      systemAdminSection: "Administrador del sistema",
      localizationSection: "Localización",
      billingSection: "Facturación",
      documentsSection: "Documentos",
      complete: "Completar configuración",
      completing: "Completando…",
      failed:
        "No se pudo completar la configuración. Revisa tus datos e inténtalo de nuevo.",
    },
  },
  dashboard: {
    title: "Panel",
    welcome: "Bienvenido de nuevo, {{name}}.",
    placeholderTitle: "Tu panel se está preparando",
    placeholderMessage:
      "Los widgets de solicitudes, ofertas y facturas abiertas aparecerán aquí en la próxima iteración.",
  },
  notifications: {
    title: "Notificaciones",
    empty: "No hay notificaciones nuevas",
  },
  notFound: {
    title: "Página no encontrada",
    message: "La página que buscas no existe o ha sido movida.",
    backHome: "Volver al panel",
  },
  offline: {
    title: "Estás sin conexión",
    message:
      "Offertli necesita conexión con el servidor. Comprueba tu red e inténtalo de nuevo.",
    retry: "Reintentar",
  },
} as const;

export default es;
